angular.module('impactx.menubutton').controller('MenuButtonCtrl', ['$scope', '$location', '$route', '$redirect', MenuButtonCtrl]);

function MenuButtonCtrl($scope) {
    var originatorEv;
    this.openMenu = function($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
    };
}